import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=23a2831e&"
import script from "./TermsOfUse.vue?vue&type=script&lang=js&"
export * from "./TermsOfUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a2831e')) {
      api.createRecord('23a2831e', component.options)
    } else {
      api.reload('23a2831e', component.options)
    }
    module.hot.accept("./TermsOfUse.vue?vue&type=template&id=23a2831e&", function () {
      api.rerender('23a2831e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vendors/TermsOfUse.vue"
export default component.exports